<template>
    <page-shell title="General Information">
        <render-content-blocks :content-blocks="contentBlocks" />
    </page-shell>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getContentBlocks } from "../../api/rest";
import RenderContentBlocks from "../content-block/RenderContentBlocks.vue";
import PageShell from "../shared/PageShell.vue";

const contentBlocks = ref([]);

onMounted(async () => {
    contentBlocks.value = await getContentBlocks("operator-info");
});
</script>
